import { Modal, Form, Row } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MyInput from "../../components/Input";
import MyButton from "../../components/Button";
import Typography from "../../components/Typography";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import Api from "../../components/httpClient";
import ModalconfirmChangepassword from "./ModalconfirmChangepassword";
import { Notification } from "../../components/Notification";
import GetProfile from "../../components/VariableStore";
import { FormattedMessage,useIntl } from "react-intl";

var client = Api();

const qs = require("query-string");

const ChangePasswordModal = (props) => {
  const { isOpen, onCancle } = props;
  const navigate = useNavigate();
  const [edit, setEdit] = useState(false);
  const isDesktop = useIsDesktop();
  const [form] = Form.useForm();
  const intl = useIntl();
  const [confirmChangepassword, setConfirmChangepassword] = useState(false);
  const [currentpass, setCurrentPass] = useState();
  const [NewPassword, setnewPassword] = useState();
  const [currentPassword, setCurrentPassword] = useState();

  const [iserror, setIserror] = useState(false);
  const customerId = GetProfile("customerId");
  const customerRefId = GetProfile("customerRefId");
  const username = GetProfile("username");
  const validateCurrentPassword = (_, value) => {
    setCurrentPassword(value);
    setIserror(false);
    return Promise.resolve();
  };

  const validateNewPassword = (_, value) => {
    setnewPassword(value);
    setIserror(false);
    if (value && value === form.getFieldValue("currentPassword")) {
      return Promise.reject(<FormattedMessage id="passwordDuplicated" defaultMessage="Password Duplicated.!" />);
    }
    return Promise.resolve();
  };

  const validateConfirmPassword = (_, value) => {
    setCurrentPass(value);
    setIserror(false);
    if (value && value !== form.getFieldValue("newPassword")) {
      return Promise.reject(<FormattedMessage id="requiredconfirmnewPasswordnotmatch" defaultMessage="The new password that you entered do not match!" />);
    }
    return Promise.resolve();
  };

  const handleOk = () => {
    form.validateFields().then((value) => {
      if (confirmChangepassword === false) {
        setConfirmChangepassword(true);
      } else {
        validateCurrentPasswordApi(value);
      }
    }).catch(() => {});;
  };

  const isClose = () => {
    form.resetFields();
    setIserror(false);
    onCancle();
  };

  const isCloseComfirmPassword = () => {
    setConfirmChangepassword(false);
  };

  const validateCurrentPasswordApi = async (value) => {
    const data = {
      client_id: `${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`,
      grant_type: "password",
      client_secret: `${process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET}`,
      // username: localStorage.getItem('username'),
      username: username,
      password: currentPassword,
    };

    const axiosConfig = {
      Header: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    try {
      client.defaults.baseURL = `${process.env.REACT_APP_KEYCLOAK_URL}`;
      client.defaults.headers = {
        Authorization: "",
        "Content-Type": "application/x-www-form-urlencoded",
      };
      const res = await client.post(
        "/auth/realms/master/protocol/openid-connect/token",
        qs.stringify(data),
        axiosConfig
      );

      //console.log(res);
      if (res.status === 200) {
        getToken();
        form.resetFields();
        setConfirmChangepassword(false);
      }

      //console.log(res);
      return res;
    } catch (err) {
      if (err.status !== currentPassword) {
        setConfirmChangepassword(false);
        form.resetFields();
        setIserror(true);
        Notification("error", intl.formatMessage({ id: 'notificationErrorPassword', defaultMessage: " Current Password failed! " }));
        return Promise.reject("Password error.!");
      }
    }
  };

  const getToken = async () => {
    //console.log(NewPassword);
    try {
      let body = {
        client_id: `${process.env.REACT_APP_CLIENT_ID}`,
        client_secret:`${process.env.REACT_APP_CLIENT_SECRET}`,
        grant_type: "password",
        
        username: "admin",
        password: "#Admin123",
      };
      setConfirmChangepassword(false);
      onCancle();
      form.resetFields();
      const res = await client.post(
        "/auth/realms/master/protocol/openid-connect/token",
        qs.stringify(body)
      );

      //console.log("res", res);
      let token = res.data.access_token;
      //console.log("token", token);

      try {
        let body = {
          type: "password",
          value: NewPassword,
        };

        client.defaults.headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        //console.log("body=", body);

        const res = await client.put(
          `/auth/admin/realms/master/users/${customerRefId}/reset-password`,
          body
        );

        //console.log("res+++++", res);

        Notification("success", intl.formatMessage({ id: 'notificationSuccessPassword', defaultMessage: 'User reset password' }));
        setEdit(!edit);
        setIserror(false);
      } catch (error) {
        Notification("error", intl.formatMessage({ id: 'notificationErrorPassword', defaultMessage: 'ChangePassword failed!' }));
      }
    } catch (error) {}
  };

  return (
    <>
      <Form form={form}>
        <Modal
          open={isOpen}
          onCancel={isClose}
          footer={
            <>
              {isDesktop && isDesktop ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "150px",
                    marginTop: "50px",
                  }}
                >
                  <MyButton
                    isPrimary
                    style={{
                      width: "30%",
                    }}
                    onClick={handleOk}
                  >
                    <FormattedMessage id="btnSave" defaultMessage="Save" />
                  </MyButton>

                  <MyButton
                    onClick={isClose}
                    style={{
                      width: "30%",
                      marginLeft: '10px',
                    }}
                  >
                    <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
                  </MyButton>
                </div>
              ) : (
                <div style={{marginTop: "30px"}}>
                  <p
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <MyButton
                      isPrimary
                      style={{
                        width: "100%",
                        marginBottom: "-9px"
                      }}
                      onClick={handleOk}
                    >
                    <FormattedMessage id="btnSave" defaultMessage="Save" />
                    </MyButton>
                  </p>
                  <p
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <MyButton
                      onClick={isClose}
                      style={{
                        width: "100%",
                      }}
                    >
                      <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
                    </MyButton>
                  </p>
                </div>
              )}
            </>
          }
        >
          <div className="d-flex flex-column px-4">
            <Typography
              fontType="heading"
              size="36px"
              lineHeight="48px"
              className="px-3 pt-5 mb-3 mt-4 text-center"
            >
              <FormattedMessage
                id="menuChangePasssword"
                defaultMessage="Change Password"
              />
            </Typography>
            <Typography
              size="12px"
              lineHeight="20px"
              className="py-3 mt-2 px-3 text-center"
            >
              <FormattedMessage
                id="changepasswordcontent"
                defaultMessage=" Please enter a current password and new password and your password should be at least 6 characters"
              />
            </Typography>

            <div style={{ marginTop: isDesktop ? "20px" : "48px" }}>
              <Form.Item
                name="currentPassword"
                rules={[
                  {
                    required: true,
                    message: <FormattedMessage id="requiredcurrentpassword" defaultMessage="Please enter your current password!" />
                  },
                  {
                    min: 6,
                    message: <FormattedMessage id="requiredcurrentpasswordmin" defaultMessage="Password should be at least 6 characters long!" />,
                  },
                  { validator: validateCurrentPassword },
                ]}
              >
                <MyInput placeHolder={intl.formatMessage({ id: 'currentPassword', defaultMessage: 'Current Password' })} isPassword />
              </Form.Item>
              <Form.Item
                name="newPassword"
                hasFeedback
                rules={[  
                  { required: true, message: <FormattedMessage id="requirednewPassword" defaultMessage="Please enter a new password!" />, },
                  {
                    min: 6, 
                    message:<FormattedMessage id="requiredcurrentpasswordmin" defaultMessage="Password should be at least 6 characters long!" />,
                  },
                  {
                    validator: validateNewPassword,
                  },
                ]}
              >
                <MyInput placeHolder={intl.formatMessage({ id: 'newPassword', defaultMessage: 'Select Customer' })} isPassword />
              </Form.Item>
              <Form.Item
                name="confirmNewPassword"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: <FormattedMessage id="requiredconfirmnewPassword" defaultMessage="Please confirm your new password!" />,
                  },
                  { validator: validateConfirmPassword },
                ]}
              >
                <MyInput placeHolder={intl.formatMessage({ id: 'confirmNewPassword', defaultMessage: 'Confirm New Password' })} isPassword />
              </Form.Item>
            </div>
          </div>
          {/* {iserror === true ? (
            <div
              style={{
                color: "red",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontSize: isDesktop ? "15px" : "15px",
              }}
            >
              <p>
                <CloseCircleOutlined
                  style={{ fontSize: isDesktop ? "38px" : "30px" }}
                />
              </p>
              <p>Current password false!</p>
              <p>Please enter your password again.</p>
            </div>
          ) : null} */}
        </Modal>
      </Form>
      <ModalconfirmChangepassword
        confirmChangepassword={confirmChangepassword}
        isCloseComfirmPassword={isCloseComfirmPassword}
        handleOk={handleOk}
      />
    </>
  );
};

export default ChangePasswordModal;
